import { State } from '.';
import { Insurance } from '../../models/insurance';

export const selectors = {
    getInsurance: (
        state: State,
        id: Undefinable<DictionaryKey>
    ): Undefinable<Insurance> => state.byId[id || ''],
    getInsuranceIds: (
        state: State
    ): number[] => state.allIds,
    getLoading: (
        state: State,
        loadingKey: string
    ): boolean => state.loading[loadingKey] || false
};
